module.exports = __webpack_public_path__ + "img/stephenson-logo.65fe786f.jpg";